import Button from 'components/Form/Button';
import { CoreContext } from 'context/CoreContext';
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { POST } from '../../../services/api';
import { CompanyButtonContainer, FormText } from '../FinalizaSol/styled';
import Wrapper from '../Wrapper';

const FinalizaSol = ({ dados, reload, origem }) => {
  const { setModal } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);

  const idchat = { idchat: dados?.idchat };
  const telefone = dados?.msgtelefone;
  const today = new Date();

  const handleError = (error) => {
    const errorMessages = {
      400: 'Dados inválidos. Verifique as informações enviadas.',
      401: 'Você não tem permissão para realizar esta ação.',
    };
    const defaultError =
      'Ocorreu um erro ao processar a requisição. Tente novamente mais tarde.';
    const errorMessage = errorMessages[error.response?.status] || defaultError;
    toast.error(errorMessage);
  };
  const handleSim = async () => {
    if (!dados?.id) {
      toast.error(
        'Não foi possível finalizar conversa. verifique se tem algum conversa aberta.'
      );
      return;
    }
    setLoading(true);
    const variaveis = {
      data: {
        proposta_financeira: dados.id,
        date: today,
        etapa: 'fatura cliente',
        observacao: 'Fechado manuamente.',
        tipo: 'recebido',
        agente: 'Vendedor',
        etapa_financiamento: 'pendente',
        telefone: telefone,
        chatid_bot: dados?.idchat,
        ocorrido: 'sem resposta',
      },
    };

    try {
      await POST('/webhook/encerrasol', idchat, true);
      await POST('/monitorings', variaveis, true);
      toast.success('encerrado com sucesso.');
      setModal(null);
      if (reload) {
        reload();
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Wrapper title="Finalizar Conversa Sol">
      <FormText>
        Deseja estar encerrando a conversa da proposta id: {dados?.id} do(a)
        cliente {dados?.customer}?
      </FormText>
      <CompanyButtonContainer>
        <Button onClick={handleSim} disabled={loading} color="blue">
          {loading ? 'Enviando...' : 'Sim, encerrar conversa'}
        </Button>
        <Button
          onClick={() => setModal(null)}
          disabled={loading}
          variant="secondary"
          color="info"
        >
          Cancelar
        </Button>
      </CompanyButtonContainer>
    </Wrapper>
  );
};
FinalizaSol.propTypes = {
  dados: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  reload: PropTypes.func,
};
export default FinalizaSol;
